module.exports = "/_next/static/images/HeroCCPA@3x-6e74dfe413b658cf613bdd6434cb0f99.webp";